// extracted by mini-css-extract-plugin
module.exports = {"courseBucket":"CourseBucket_courseBucket__twZkD","bucketImage":"CourseBucket_bucketImage__1o8OC","bucketTitle":"CourseBucket_bucketTitle__36bQi"};